import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch ,useSelector } from "react-redux";
import {quitMemberClubRequest} from "../../../../store/actionCreators/member";
import {closeDialog, openDialog} from "../../../../store/actionCreators/dialog";
import {Link, useHistory} from 'react-router-dom';
import {getCurrentClubId} from "../../../../store/selectors";
import '../../../../assets/stylesheets/ClubSlide/ClubsMenu.scss';

const MemberMenu =() => {
  const { t } = useTranslation();
    const dispatch = useDispatch();
    const clubId = useSelector(getCurrentClubId);
    const history = useHistory();

    const quitClub = () => {
        dispatch(quitMemberClubRequest(history));
    };

    const promptQuitClub = () => {
        dispatch(openDialog(
            'quitMemberClub',
            {
                realDialog: true,
                title: 'notification',
                footer: 'confirm',
                onConfirm: quitClub,
            },
        ));
    };

    return (
        <div className={`menuOptions`}>
            <Link
                to={{pathname: `/club/${clubId}/trades`, isMember: true}}
                onClick={()=>dispatch(closeDialog())}
            ><div>{t('tradeRecords')}</div></Link>
           {/* <div className={`optionName`} onClick={promptQuitClub}>{t['quitTheClub']}</div> */}
        </div>
    );
};

export default MemberMenu;
